"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parse;
exports.hasMarkdownCharacters = hasMarkdownCharacters;
exports.parseBoldText = parseBoldText;
exports.parseItalicText = parseItalicText;
exports.parseLinks = parseLinks;

function parseBoldText(text) {
  return text.replace(/\*\*([^ \*].+?)\*\*/gm, "<strong>$1</strong>");
}

function parseItalicText(text) {
  return text.replace(/\*([^\* ]*?[^\* ])\*/gm, "<em>$1</em>");
}

function parseLinks(text) {
  return text.replace(/\[([^\]]+?)\]\((.+?)\)/gm, "<a href='$2' target='_blank'>$1</a>");
}

function hasMarkdownCharacters(text) {
  //does it include * or [ characters?
  return /[\[\*]/.test(text);
}

function parse(text) {
  let value = text;
  value = parseBoldText(value);
  value = parseItalicText(value);
  value = parseLinks(value);
  return value;
}